export default __webpack_public_path__ + "static/media/idol@2x.5b789ff5.png";